import React from 'react'
import { useSelector } from 'react-redux'

const ApplyLoan = () => {
  const {cityData} = useSelector(state => state.CityWiseIplReducer)
  return (
    <section id="applyLoan" className='apply-personal-loan'>
        <div className='heading'>
          Hassle-free personal loan <br/> application process in {cityData?.city}
        </div>
        <div className='loan-steps-container' data-aos='fade-up' data-aos-duration='800'>
          <div className='loan-steps'>
            <div className='steps'>
              <div>
                <span className='steps-number-label' data-aos='zoom-in' data-aos-delay='700'>
                  01
                </span>
                <p data-aos='fade-up' data-aos-delay='1000'>
                  Download <br/> Stashfin app <br/> and sign in
                </p>
              </div>
              <div
                className='steps-link-line'
                data-aos='fade-right'
                data-aos-delay='1300'
                data-aos-easing='linear'
              >----------
              </div>
              <div>
                <span className='steps-number-label' data-aos='zoom-in' data-aos-delay='1500'>
                  02
                </span>
                <p data-aos='fade-up' data-aos-delay='1800'>
                  Apply for the
                  <br /> Credit Line
                </p>
              </div>
              <div className='steps-link-line' data-aos='fade-right' data-aos-delay='2100'>
                ----------
              </div>
              <div>
                <span className='steps-number-label' data-aos='zoom-in' data-aos-delay='2300'>
                  03
                </span>
                <p data-aos='fade-up' data-aos-delay='2500'>
                 Complete your <br /> KYC
                </p>
              </div>
              <div className='steps-link-line' data-aos='fade-right' data-aos-delay='2600'>
                ----------
              </div>
              <div>
                <span className='steps-number-label' data-aos='zoom-in' data-aos-delay='2700'>
                  04
                </span>
                <p data-aos='fade-up' data-aos-delay='2800'>
                 Transfer funds <br/> to your bank
                </p>
              </div>
            </div>
            <div data-aos='zoom-in' data-aos-delay='2900' className='text'>
                It’s that simple!
            </div>
          </div>
         </div>
    </section>
  )
}

export default ApplyLoan
